// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fc92aa5e","239":"ad1f173a","455":"1c15e803"}[chunkId] + ".chunk.js";
};